import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { PageInfoService, PageLink } from '@metronic/layout';
import { UtilitiesService } from '@services/utilities.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { API } from '@config/constants/api.constant';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { FilterService } from '@services/filter.service';
import { RetailerService } from '../retailer.service';
import { TabListLabelTerverifikasi } from '../enum/tablist-label.enum';
import { RolePrivilegeService } from '@services/role-privilege.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from '@services/base-service.service';
import { TerverifikasiNonactiveComponent } from './terverifikasi-nonactive/terverifikasi-nonactive.component';
import { TerverifikasiActiveComponent } from './terverifikasi-active/terverifikasi-active.component';
import { MatTabChangeEvent } from '@angular/material/tabs';

@Component({
  selector: 'app-terverifikasi',
  templateUrl: './terverifikasi.component.html',
  styleUrls: ['./terverifikasi.component.scss'],
})
export class TerverifikasiComponent implements OnInit, AfterViewInit, OnDestroy {
  // @ViewChild(MatSort, {static: false}) matSort: MatSort;
  @Output() totalCount = new EventEmitter();

  STRING_CONSTANTS = STRING_CONSTANTS;
  iconNone = STRING_CONSTANTS.ICON.IC_RETAIL_NONE;
  isLoading = false;

  links: Array<PageLink> = [
    {
      title: 'Retailer',
      path: '',
      isActive: false,
    },
    {
      title: '',
      path: '',
      isActive: false,
      isSeparator: true,
    },
    {
      title: 'Terverifikasi',
      path: '',
      isActive: true,
    },
  ];

  private unsubscribe: Subscription[] = [];

  constructor(
    private pageInfoService: PageInfoService,
    public utilities: UtilitiesService,
    public filterService: FilterService,
    public retailerService: RetailerService,
    private rolePrivilegeService: RolePrivilegeService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private baseService: BaseService
  ) {}

  @ViewChild('terverifikasiActive', { static: true }) activeTpl!: TemplateRef<any>;
  @ViewChild('terverifikasiNonactive', { static: true }) nonactiveTpl!: TemplateRef<any>;

  TabListLabel = TabListLabelTerverifikasi;
  tabList: any[] = [];

  countActive = new BehaviorSubject(0);
  countNonActive = new BehaviorSubject(0);

  tabIndex: number = 0;
  tab: any | null = null;

  ngOnInit() {
    this.initTabList();
    this.initPageInfo();
    this.handlePrivilege();
  }

  initPageInfo() {
    this.pageInfoService.updateTitle(`Retailer Terverifikasi`);
    this.pageInfoService.updateBreadcrumbs(this.links);
  }

  ngAfterViewInit() {
    this.initGetListDataCount();
  }

  initTabList() {
    // TODO: change privilege with new privilege
    this.tabList = [
      {
        tab: 'active',
        enumChild: 'TAB_LIST_ACTIVE',
        labelKey: 'active',
        privilege: null,
        dataCount: this.countActive,
        component: TerverifikasiActiveComponent,
        template: this.activeTpl,
      },
      {
        tab: 'nonactive',
        enumChild: 'TAB_LIST_NONACTIVATED',
        labelKey: 'nonactive',
        privilege: null,
        dataCount: this.countNonActive,
        component: TerverifikasiNonactiveComponent,
        template: this.nonactiveTpl,
      },
    ];

    this.activatedRoute.paramMap.subscribe((params) => {
      this.tab = params.get('tab');
      const _currentActiveTab = this.tabList.find((item) => item.tab === this.tab);
      this.tabIndex = this.tabList.indexOf(_currentActiveTab);
    });
  }

  handlePrivilege() {
    this.tabList.map((tab) => {
      tab.privilege = this.rolePrivilegeService.checkPrivilege('RETAILER', 'LIST_RETAILER_TERVERIFIKASI', tab.enumChild);
    });

    this.changeFirstTab();
  }

  changeFirstTab() {
    const _data: { tab: string; privilege: boolean }[] = [];
    this.tabList.forEach((item) => {
      _data.push({ tab: item.tab, privilege: !!item.privilege });
    });

    if (!this.tabList[0].privilege) {
      const _changeTab = this.rolePrivilegeService.changePrivilegeUrlTab(_data, 'retailer', 'terverifikasi');
      this.router.navigate([_changeTab]).then();
    }
  }

  tabClick(e: MatTabChangeEvent) {
    this.tabIndex = e.index;

    const _tabLabel = e.tab.textLabel;
    const _indexOfTab = Object.values(TabListLabelTerverifikasi).indexOf(_tabLabel as TabListLabelTerverifikasi);

    const { tab } = this.tabList[_indexOfTab];

    this.router.navigate([`/retailer/terverifikasi/${tab}`]).then(() => this.initPageInfo());
  }

  initGetListDataCount() {
    const _dataCounterSubs = this.baseService.getData<any>(API.RETAILER.LIST_COUNTER.REGISTRATION).subscribe((resp) => {
      if (!resp) return;
      const { count_active, count_nonactive } = resp && resp.data;
      this.countActive.next(count_active);
      this.countNonActive.next(count_nonactive ?? 0);
    });

    this.unsubscribe.push(_dataCounterSubs);
  }

  ngOnDestroy(): void {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  protected readonly API = API;
}
